<template>
  <div class="reward-box">
    <div style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      ">
      <img src="@/assets/themeFour/treasure_holder_single.png" style="width: 100%; position: absolute; bottom: 1%" />

      <div class="container">
        <img src="@/assets/themeFour/treasure_amountbg.png"
          style="width: 100%;position: absolute;bottom: 28%;left: 0.5px;" />
        <img v-if="received != 1" class="box-img" :src="boxImg" alt="" />
        <img v-else class="box-img" :src="boxImg2" alt="" />
        <div class="rewardNum" :style="{
          padding: '5px 0',
          color: received == 1 ? 'gold' : 'rgba(255,255,255,.6)',
          fontWeight: received == 1 ? '600' : '700',
        }">
          {{ parseFloat(reward).toFixed(2).toString().replace(".", ",") }}
        </div>
        <div class="overlay-text">
          <div :style="{
            color: received != 1 ? 'rgba(255,255,255,.6)' : 'rgba(255,255,255,.6)',
            fontWeight: received == 1 ? '700' : '700',
            marginTop: '5px',
          }">
            {{ $t("common.promotion") }}
            <span style="color:rgb(83,193,84);font-weight: 600;">{{ peopleCount }}</span>
            <p style="margin-top: 0px">{{ $t("common.pepole") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "RewardBox",
  props: {
    peopleCount: {
      type: Number,
      required: true,
    },
    reward: {
      type: String,
      required: true,
    },
    arrow: {
      type: String,
      required: false,
    },
    down: {
      type: Boolean,
      required: false,
      default: false,
    },
    side: {
      type: String,
      required: false,
    },
    isInCorner: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false,
    },
    boxImg: {
      type: String,
      default: () => require("@/assets/themeFour/treasureBoxClose.png"),
    },
    boxImg2: {
      type: String,
      default: () => require("@/assets/themeThree/treasureBoxOpen.png"),
    },
    received: {
      type: Number,
      default: () => 0,
      required: true,
    },
  },
});
</script>

<style scoped>
.reward-box {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.box-img {
  width: 60%;
  /* height: 49px; */
}

.dimmed {
  filter: brightness(50%);
}

.completeBox {
  width: 17vw;
  /* height: 49px; */
  background: green;
}

.arrow-img {
  width: 25px;
  height: 25px;
  margin-top: 5px;
  margin-left: 10px;
}

.rewardNum {
  position: absolute;
  /* text-shadow: -1px -1px 1px red, 1px -1px 1px red, -1px 1px 1px red, */
  /* 1px 1px 1px red; */
  top: 48%;
  font-size: 0.658rem;
}

.arrow-img-down {
  display: flex;
  justify-content: center;
  width: 25px;
  height: 25px;
  /* margin-top: 27px; */
  /* margin-left: 15px; */
}

.container {
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.overlay-text {
  /* position: absolute;
    top: 53px;
    height: 49px;
    width: 90%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 0.65rem;
  color: white;
  margin-top: 20px;
}

@media (min-width: 400px) {
  .box-img {
    /* width: 68px !important; */
  }
}

@media (min-width: 1440px) {
  .arrow-img-down {
    /* margin-right: 30px; */
    width: 35px;
    height: 35px;
  }

  .arrow-img {
    margin-left: 1vw;
    width: 35px;
    height: 35px;
  }

  .box-img {
    /* width: 68px; */
    width: 5.25rem;
  }

  .rewardNum {
    font-size: 0.888rem;
  }
}

@media (min-width: 1920px) {
  .arrow-img-down {
    /* margin-right: 50px; */
  }

  .arrow-img {
    margin-left: 1vw;
    height: 1vw;
    width: 1vw;
  }

  .arrow-img-down {
    height: 1vw;
    width: 1vw;
  }
}
</style>
